import { ReactNode } from 'react';

import { clsx } from '@freelancelabs/utils';

export interface CardField {
    label: string;
    /** A field with no value renders a dash rather than an empty row: an absent
     *  value is information, a missing row looks like a bug. */
    value?: ReactNode;
    /**
     * The row holds a sentence **about** the field rather than the field's value:
     * « non disponible », « pas encore affiché ici ».
     *
     * Set apart on purpose, and the dash above is why: a dash says « this object has
     * none », which is a claim about the object, where these sentences are claims
     * about what we serve. Rendered in the weight of a value, they would be read as
     * one.
     */
    muted?: boolean;
}

interface Props {
    fields: CardField[];
    className?: string;
}

/** Label and value pairs of a detail sheet, in two columns when the width allows. */
const CardFields = ({ fields, className }: Props) => (
    <dl className={clsx('fl-card__fields', className)}>
        {fields.map(({ label, value, muted }) => (
            <div key={label}>
                <dt>{label}</dt>
                <dd className={clsx(muted && 'fl-card__field-value--muted')}>{value ?? '-'}</dd>
            </div>
        ))}
    </dl>
);

export default CardFields;
